import axios from 'axios';

import configs from 'config';
import { getAppInfo, getURLParameter, getAppVersion, CleverTapEventV2, CLEVERTAP } from 'utils';
import globalConstant from 'constants/globalConstant';
import MESSAGE_CONSTANT from 'constants/msgConstant';

const Request = axios.create({
	baseURL: configs.consumer,
	headers: { 'Content-Type': 'application/json' },
});

const serializeError = (error) => {
	const { response } = error;
	if (!response) throw error;
	const { status, statusText, data } = response;
	const { message } = data;
	let errorMsg = '';
	try {
		errorMsg = JSON.parse(message).error.debug_msg;
	} catch (e) {
		errorMsg = message;
	}
	if (status?.toString() === '503') {
		CleverTapEventV2.send(CLEVERTAP.EVENTS.API_ERROR_503, {
			api_url: `${response?.config?.baseURL}${response?.config.url}`,
		});
	}
	const errorObj = {
		name: 'API ERROR',
		message: errorMsg || statusText || MESSAGE_CONSTANT.SOMETHING_WRONG,
		code: status.toString(),
		stack: JSON.stringify(error.toJSON()),
	};
	return errorObj;
};

const tokenHeaderInterceptor = (config) => {
	var visa =
		getAppInfo()?.[globalConstant.URL_PARAMETER.TOKEN] ||
		getAppInfo()?.[globalConstant.URL_PARAMETER.VISA] ||
		getURLParameter(globalConstant.URL_PARAMETER.TOKEN) ||
		getURLParameter(globalConstant.URL_PARAMETER.VISA);
	config.headers['token'] = visa;
	config.headers['latitude'] = getAppInfo()?.latitude || '';
	config.headers['longitude'] = getAppInfo()?.longitude || '';
	config.headers['installId'] = getAppInfo()?.[globalConstant.URL_PARAMETER.INSTALL_ID] || '';
	config.headers['device'] = getAppInfo()?.[globalConstant.URL_PARAMETER.DEVICE_ID] || '';
	config.headers['simId'] = getAppInfo()?.[globalConstant.URL_PARAMETER.SIM_ID] || '';
	config.headers['appversion'] = getAppVersion() || '';
	config.headers['clientid'] = 'postpe_internal';
	return config;
};

const onErrorInterceptor = (error) => {
	throw serializeError(error);
};

Request.interceptors.request.use(tokenHeaderInterceptor);
Request.interceptors.response.use(undefined, onErrorInterceptor);

const extractor = (response) => {
	const { status, data, statusText } = response;
	if (status !== 200) throw new Error(statusText);
	if (!data || data.statusCode !== '200') throw new Error(data.message);
	return data.data;
};

export const GetRequestForConsumer = (path, params) => Request.get(path, { params }).then(extractor);

export const PostRequestForConsumer = (path, payload) => Request.post(path, payload).then(extractor);
export const GetRequestForConsumer2 = (path, params) => Request.get(path, { params }).then((data) => data.data);
